import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Button, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

const OddsButtonBase = styled(Button)`
  flex-wrap: wrap;
  height: 48px;
  width: 100%;
  padding: ${props => props.theme.spacing(1)}px;
  color: ${props => props.theme.palette.text};
  background-color: ${props => props.theme.palette.oddsButton.default};

  &:hover {
    background-color: ${props => props.theme.palette.oddsButton.hover};
  }

  ${props =>
    props.selected &&
    css`
      background-color: ${props.theme.palette.primary.main};
      &:hover {
        background-color: ${props.theme.palette.primary.main};
      }
    `}

  ${props =>
    props.disabled &&
    css`
      color: #ddd;
    `}

    & .MuiButton-label {
    flex-direction: column;
    min-width: 50px;
  }
`
const OutcomeName = styled.div`
  flex: 0 0 100%;
  width: 80%;
  font-size: 0.688rem;
  letter-spacing: 0.01786rem;
  line-height: 1.125rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.color};
`
const OutcomeOddsValue = styled.div`
  font-size: 0.875rem;
  line-height: 0.875rem;
  font-weight: bold;
  color: ${props => props.color};
`

const OddsButton = props => {
  const { teamTitle, value, isSelected, isDisabled, clickHandler } = props
  const theme = useTheme()
  const contrastText = theme.palette.getContrastText(theme.palette.primary.main)

  return (
    <OddsButtonBase
      variant="contained"
      onClick={clickHandler}
      disabled={isDisabled}
      selected={isSelected}
    >
      <OutcomeName
        color={isSelected ? contrastText : theme.palette.text.secondary}
        selected={isSelected}
        disabled={isDisabled}
      >
        {teamTitle}
      </OutcomeName>
      <OutcomeOddsValue
        selected={isSelected}
        disabled={isDisabled}
        color={isSelected ? contrastText : theme.palette.primary.main}
      >
        {parseFloat(value)}
      </OutcomeOddsValue>
    </OddsButtonBase>
  )
}

OddsButton.propTypes = {
  teamTitle: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  isSelected: PropTypes.object,
  isDisabled: PropTypes.bool,
  clickHandler: PropTypes.func.isRequired,
}

export default OddsButton
